import { Menu, Popover } from "antd";
import FlatSquareButton from "../FlatSquareButton/FlatSquareButton";
import { useDispatch } from "react-redux";
import { setCurrentlyOpenModal } from "../../redux";
import { floatingMenuWidth, modals } from "../../util/constants";
import { useState } from "react";
import { iconSize } from "../../config";
import { ImportModal } from "../ImportModal";
import { EllipsisVertical, Import } from "lucide-react";

const items = [
  {
    label: "Import ...",
    key: "import",
    icon: <Import size={iconSize} />,
  },
];

const MoreMenuContent = ({ onSelect }) => {
  const dispatch = useDispatch();
  const onClick = ({ key }) => {
    switch (key) {
      case "import":
        dispatch(setCurrentlyOpenModal(modals.import));
        break;
      default:
        throw new Error(`Invalid menu option ${key}`);
    }
    onSelect();
  };
  return (
    <Menu
      items={items}
      onClick={onClick}
      style={{ width: floatingMenuWidth }}
    />
  );
};

export const HotspotListMoreMenu = () => {
  const [open, setOpen] = useState(false);
  const hide = () => {
    setOpen(false);
  };
  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };
  return (
    <>
      <Popover
        content={<MoreMenuContent onSelect={hide} />}
        trigger="click"
        placement="bottomRight"
        arrow={false}
        open={open}
        onOpenChange={handleOpenChange}
        style={{ border: "3px solid yellow", width: "100%" }}
      >
        <FlatSquareButton>
          <EllipsisVertical size={iconSize} />
        </FlatSquareButton>
      </Popover>
      <ImportModal />
    </>
  );
};
